import React from "react"
import { useMyProfileQuery } from "../../../../services/profileService/profile-api"
import { Card, CardActions, CardContent, Grid } from "@mui/material";
import RevRecIcon from '../../../../images/appicons/RevRec.png';

function RevRecCard(){
    const {data} = useMyProfileQuery();
    const canAccess=():boolean=>{
        if(data?.role === 'Admin'){return true;}
        if(data?.claimsAccess.find(p => p.code === 'RevRec') != undefined){return true;}
        return false;
    }

    return <React.Fragment>
        {canAccess() &&
            <Grid item sm={3}>
                <Card className='card-img-body center-align'>
                    <CardContent className='card-img-main'>
                        <a className='btn img-button' href={'/RevRec'}><img className='card-img' src={RevRecIcon} alt=''/></a>
                    </CardContent>
                    <CardActions className='card-img-footer'><h6>Revenue Recognition</h6></CardActions>
                </Card>
            </Grid>
        }
    </React.Fragment>
}

export{RevRecCard}